import React, { useContext } from 'react'
import { Radio, RadioGroup, FormControlLabel, FormControl, FormLabel, Tooltip } from "@mui/material"
import { LoadingContext } from '../M_Utils'

export default function M_RadioButton({ label, options, selectedValue,
    onChange, required, disabled, tooltipName, labelColors, radioColors }) {
    const ctx = useContext(LoadingContext)

    labelColors = labelColors || ctx.secondaryColor || 'var(--color-black)'
    radioColors = radioColors || ctx.primaryColor || 'var(--color-black)'

    return (
        <FormControl>
            <FormLabel style={{ color: labelColors }} id="radio-buttons">{label}</FormLabel>
            <RadioGroup
                aria-labelledby="radio-buttons"
                value={selectedValue}
                onChange={onChange}
            >
                <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
                    {options?.map((option, key) => (
                        <Tooltip key={key} title={option.label}>
                            <FormControlLabel
                                key={key}
                                required={required}
                                value={option.value}
                                control={
                                    <Radio disableRipple
                                        sx={{
                                            '&, &.Mui-checked': {
                                                color: radioColors,
                                            },
                                            '&:hover': {
                                                backgroundColor: 'transparent !important',
                                            },
                                        }}
                                    />
                                }
                                label={option.label}
                                disabled={disabled}
                            />
                        </Tooltip>
                    ))}
                </div>
            </RadioGroup>
        </FormControl>
    )
}